import { RouteObject } from "react-router-dom";
import WorkflowLanding from "./landing/landing";
import WorkflowsDetailsLanding from "./tabs/workflows/details/landing/landing";
import ExecutionDetailsLanding from "./tabs/workflows/details/executionDetails/landing/landing";
import CreateWorkflow from "./tabs/workflows/create/create";

export interface uxWorkflowRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxWorkflowRoute[];
}

export const uxWorkflowRoutes: uxWorkflowRoute[] = [
  {
    path: "communication-hub/workflows",
    element: <WorkflowLanding />,
  },
    {
    path: "communication-hub/workflows/:action",
    element: <CreateWorkflow />,
  },
  {
    path: "communication-hub/workflows/:action/:id",
    element: <CreateWorkflow />,
  },
  {
    path: "communication-hub/workflows/view/:id",
    element: <WorkflowsDetailsLanding />,
  },
  {
    path: "communication-hub/workflows/view/:id/execution-details",
    element: <ExecutionDetailsLanding />,
  },
];
